import Counter from './ClassCounter';

export default Counter;